var render = function render(){var _vm=this,_c=_vm._self._c;return _c('progress-bar',{staticClass:"judging-progress-bar",attrs:{"value":_vm.picksUsed,"total":_vm.total,"units":_vm.units}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }